
import {isDevContext} from "../util/context.js";

const GAIA_HOME = "https://gaia.nullschool.net";
const GAIA_ROOT = isDevContext() ? "" : GAIA_HOME;

export function gaiaPath(...parts) {
    return [GAIA_ROOT, ...parts].join("/");
}
